import React from 'react';
import { useSelector } from 'react-redux';

const Blog = () => {
  const language = useSelector((state) => state.language);

  const posts = [
    {
      en: {
        title: "Getting Started with RAQIB",
        excerpt: "Learn how to set up and configure RAQIB for your clinic in just a few minutes.",
        date: "March 15, 2026"
      },
      fr: {
        title: "Démarrer avec RAQIB",
        excerpt: "Découvrez comment configurer RAQIB pour votre clinique en quelques minutes.",
        date: "15 mars 2026"
      },
      ar: {
        title: "الحصول على أساسيات RAQIB",
        excerpt: "تعلم كيفية إعداد RAQIB لعيادتك في دقائق معدودة.",
        date: "15 مارس 2026"
      }
    },
    {
      en: {
        title: "Best Practices for Patient Data Management",
        excerpt: "Discover the best practices for managing patient data securely and efficiently.",
        date: "March 10, 2026"
      },
      fr: {
        title: "Meilleures pratiques de gestion des données des patients",
        excerpt: "Découvrez les meilleures pratiques pour gérer les données des patients de manière sécurisée.",
        date: "10 mars 2026"
      },
      ar: {
        title: "أفضل الممارسات لإدارة بيانات المريض",
        excerpt: "اكتشف أفضل الممارسات لإدارة بيانات المريض بأمان وكفاءة.",
        date: "10 مارس 2026"
      }
    },
    {
      en: {
        title: "Why Healthcare Providers Choose RAQIB",
        excerpt: "Explore the reasons why thousands of healthcare providers trust RAQIB.",
        date: "March 5, 2026"
      },
      fr: {
        title: "Pourquoi les prestataires de soins de santé choisissent RAQIB",
        excerpt: "Explorez les raisons pour lesquelles les prestataires de soins de santé choisissent RAQIB.",
        date: "5 mars 2026"
      },
      ar: {
        title: "لماذا يختار مقدمو الرعاية الصحية RAQIB",
        excerpt: "اكتشف الأسباب التي تجعل مقدمي الرعاية الصحية يختارون RAQIB.",
        date: "5 مارس 2026"
      }
    }
  ];

  const getPostData = (post) => {
    if (language === "ar") return post.ar;
    if (language === "fr") return post.fr;
    return post.en;
  };

  return (
    <div className={`min-h-screen bg-gradient-to-br from-white via-blue-50 to-indigo-50 py-20 px-4`} dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="container mx-auto max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          {language === "ar" ? "المدونة" : language === "fr" ? "Blog" : "Blog"}
        </h1>

        <div className="space-y-6">
          {posts.map((post, idx) => {
            const postData = getPostData(post);
            return (
              <article key={idx} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow cursor-pointer">
                <div className="flex justify-between items-start mb-3">
                  <h2 className="text-2xl font-bold text-gray-900 flex-1">{postData.title}</h2>
                  <span className="text-sm text-gray-500 ml-4 whitespace-nowrap">{postData.date}</span>
                </div>
                <p className="text-gray-600 leading-relaxed">{postData.excerpt}</p>
                <button className="mt-4 text-teal-500 hover:text-teal-600 font-semibold">
                  {language === "ar" ? "اقرأ المزيد" : language === "fr" ? "Lire la suite" : "Read More"}
                </button>
              </article>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Blog;
